/**
 * L2 only: L0/L1 devices this device does not use as ADS-B master
 */

import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { useDevices } from '../../contexts/DevicesContext';
import { Device } from '../../types/Device';
import { exclusionCandidates } from '../../types/levels';

interface ExcludedMastersProps {
  deviceId: number;
  value: number[];
  onChange: (ids: number[]) => void;
  disabled?: boolean;
}

const label = (d: Device) => `${d.name || d.mqtt_id} (L${d.level})`;

const ExcludedMasters: React.FC<ExcludedMastersProps> = ({ deviceId, value, onChange, disabled = false }) => {
  const { devices } = useDevices();
  const options = exclusionCandidates(devices, deviceId);
  const selected = options.filter((d) => value.includes(d.id));

  return (
    <Autocomplete
      multiple
      options={options}
      value={selected}
      getOptionLabel={label}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, devs) => onChange(devs.map((d) => d.id))}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Excluded ADS-B masters"
          size="small"
          helperText="All L0/L1 masters are used unless excluded"
        />
      )}
    />
  );
};

export default ExcludedMasters;
